import React from "react";
import "./cookie.css";
import Cookies from "js-cookie";

class Cookie extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cookieShow: true,
    };
  }
  componentWillMount() {
    
    var cookieValue = Cookies.get("ET-Holiday-tracking-consent");
    if (cookieValue != null) {
      this.setState({ cookieShow: false });
    }
  }
  setCookie = () => {
    
    Cookies.set("ET-Holiday-tracking-consent", "true");
    this.setState({ cookieShow: false });
  };
  render() {
    if (this.state.cookieShow) {
      return (
        <div id="cookie-dialog-consent">
          <div>
            <strong>Cookie usage notification: : </strong>We use owned and
            third-party cookies to improve our services. If you continue to
            browse, we consider you accept this use.&nbsp;Please read our&nbsp;
            <a
              href="https://www.ethiopianairlines.com/aa/privacy-policy"
              target="_blank"
              style={{ color: "#fff" }}
            >
              <u>Privacy Policy</u>
            </a>
            &nbsp;&nbsp;
            <button
              type="button"
              className="conset-btn"
              onClick={this.setCookie}
            >
              I accept
            </button>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
export default Cookie;
